








import { Component, Vue } from 'vue-property-decorator';
import { app } from '@store/modules/app';
import BasicBanner from '@components/layout/basic-banner.vue';

@Component({
	components: {
		BasicBanner
	}
})
export default class InvestorUpdateBanner extends Vue {
	dismissalKey = 'dismiss-innovation-fund-banner';

	bannerCta = {
		text: 'Learn more',
		href: '/offerings/26/view'
	};

	bannerCopy = 'Fundrise launches brand new Innovation Fund.';

	get showBanner(): boolean {
		return !app.isAuthenticated;
	}
}
